export var NewYearHorseType;
(function (NewYearHorseType) {
    NewYearHorseType[NewYearHorseType["SKY_WING"] = 1] = "SKY_WING";
    NewYearHorseType[NewYearHorseType["CRIMSON_FLAME"] = 2] = "CRIMSON_FLAME";
    NewYearHorseType[NewYearHorseType["METEOR"] = 3] = "METEOR";
    NewYearHorseType[NewYearHorseType["AUSPICIOUS"] = 4] = "AUSPICIOUS";
    NewYearHorseType[NewYearHorseType["GALLOPING"] = 5] = "GALLOPING";
    NewYearHorseType[NewYearHorseType["GLORY"] = 6] = "GLORY";
    NewYearHorseType[NewYearHorseType["CLOUD_SOARING"] = 7] = "CLOUD_SOARING";
    NewYearHorseType[NewYearHorseType["THOUSAND_MILE"] = 8] = "THOUSAND_MILE";
    NewYearHorseType[NewYearHorseType["GOLDEN"] = 9] = "GOLDEN";
})(NewYearHorseType || (NewYearHorseType = {}));
export var NewYearCategoryType;
(function (NewYearCategoryType) {
    NewYearCategoryType[NewYearCategoryType["LIVE"] = 1] = "LIVE";
    NewYearCategoryType[NewYearCategoryType["VIDEO_AND_CARD"] = 2] = "VIDEO_AND_CARD";
    NewYearCategoryType[NewYearCategoryType["SPORT_AND_E_SPORT"] = 3] = "SPORT_AND_E_SPORT";
})(NewYearCategoryType || (NewYearCategoryType = {}));
export var NewYearBonusType;
(function (NewYearBonusType) {
    NewYearBonusType["BONUS_0"] = "0";
    NewYearBonusType["BONUS_8"] = "8";
    NewYearBonusType["BONUS_18"] = "18";
    NewYearBonusType["BONUS_28"] = "28";
    NewYearBonusType["BONUS_58"] = "58";
    NewYearBonusType["BONUS_88"] = "88";
})(NewYearBonusType || (NewYearBonusType = {}));
//# sourceMappingURL=NewYear.js.map